export default __webpack_public_path__ + "static/therapy-header-image-41372b770f775bc69efd3ee3a4db84f5.webp";